import * as React from "react";
import {Callout, CalloutType} from "components/Callout";
import ExternalLink from "components/ExternalLink/ExternalLink";

const AzureServerTargetRolesInfo = (props: {stepTargetRoles: string}) => {
    return props.stepTargetRoles
        ? <Callout type={CalloutType.Information}>
            Ensure you have at least one active deployment target matching the selected role(s) at the time of your
            deployment. <ExternalLink href="CloudRegionTargets">Cloud Region targets</ExternalLink> can be
            used when deploying cloud applications to multiple geographic regions.
        </Callout>
        : null;
};

export default AzureServerTargetRolesInfo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/azurePowerShell/AzureServerTargetRolesInfo.tsx